import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { ThemeComponent, getComponentStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-datepicker',
  standalone: true,
})
export class FlxDatepickerCalendarThemeDirective implements AfterViewInit {
  #host = inject(ElementRef).nativeElement as HTMLElement

  ngAfterViewInit(): void {
    const styleClass = getComponentStyles(ThemeComponent.DatepickerCalendar, theme())
    if (!styleClass) {
      return
    }
    // air-datepicker's default body-level global container
    this.#applyTheme(document.querySelector('#air-datepicker-global-container'), styleClass)
    // when the field sits inside a CDK top-layer overlay the toolkit appends the
    // calendar into that overlay so it clears the modal; theme that host too, else
    // the calendar renders outside the themed subtree (transparent)
    const overlayHost = this.#host.closest('.cdk-overlay-pane, [popover]')
    this.#applyTheme(overlayHost, styleClass)
    // and the overlay's own global container, so `flx-themed` lands on it and the
    // unthemed fallback rules (higher specificity) stop overriding the theme
    this.#applyTheme(
      overlayHost?.querySelector(':scope > .air-datepicker-global-container') ?? null,
      styleClass
    )
  }

  #applyTheme(el: Element | null, styleClass: string): void {
    if (el && !el.className.split(' ').includes(styleClass)) {
      el.className += ` ${styleClass} flx-themed`
    }
  }
}
